module.exports = __webpack_public_path__ + "img/product_image.d5735f95.png";